module.exports = __webpack_public_path__ + "media/images/front/icons/timeline-c8c68505da02a2e0e5e7fc0a08e5f172.png";